import { useLoaderData, useNavigate } from "react-router-dom";
import { getCollectionDetails } from "../../api/Get";
import Typography from "antd/es/typography";
import { Button, List } from "antd";
import SerieCard from "../series/SerieCard";

const { Title } = Typography;

const collectionDetailsLoader = async ({ params }) => {
  const details = await getCollectionDetails(params.uidCollection);
  return details;
};

const CollectionDetails = () => {
  const navigate = useNavigate();
  const { series, collection } = useLoaderData();

  const renderRow = (serie) => {
    return <SerieCard serie={serie} />;
  };

  return (
    <>
      <Title level={2}>Collection - {collection.name}</Title>
      <Button
        onClick={() => {
          navigate(`/serie/add`, {
            state: { collectionName: collection.name },
          });
        }}
      >
        Ajouter une série
      </Button>
      <br />
      <br />
      <List
        style={{ marginTop: 20 }}
        size="small"
        grid={{ column: 3 }}
        dataSource={series}
        renderItem={renderRow}
      />
    </>
  );
};

export { CollectionDetails, collectionDetailsLoader };
